import moment, { Moment } from 'moment';

export type TimeStep = 2 | 5 | 10 | 15;

export function roundTimeStringToStep (
	time: string,
	step: TimeStep = 15,
	toLower?: boolean,
): string {
	const [ hours, minutes ] = time.split(':').map(Number);

	const remainder = minutes % step;
	let roundedMinutes;

	if (toLower) {
		roundedMinutes = minutes - remainder;
	}
	else {
		roundedMinutes = remainder === 0 ? minutes : minutes + (step - remainder);
	}

	let roundedHours = hours;
	if (roundedMinutes >= 60) {
		roundedMinutes -= 60;
		roundedHours += 1;
	}

	const formattedHours = String(roundedHours).padStart(2, '0');
	const formattedMinutes = String(roundedMinutes).padStart(2, '0');

	return `${ formattedHours }:${ formattedMinutes }`;
}

export function assembleDate (date: string, time: string): Moment | null {
	if (!isValidDate(date) || !isValidTime(time)) {
		return null;
	}

	const isoString = `${ date }T${ time }`;
	const value = moment(isoString, true);

	return value.isValid() ? value : null;
}

export function isValidDate (date: string, format = 'YYYY-MM-DD'): boolean {
	return moment(date, format, true).isValid();
}

export function isValidTime (time: string): boolean {
	return moment(time, 'HH:mm:ss', true).isValid() || moment(time, 'HH:mm', true).isValid();
}

export type TimeRange = {
  start: string;
  end: string;
};


export function divideTimeRange (
	startTimeStr: string,
	endTimeStr: string,
	divisions: number,
): TimeRange[] {
	const format = 'HH:mm';
	const start = moment(startTimeStr, format);
	const end = moment(endTimeStr, format);

	const totalMinutes = end.diff(start, 'minutes');
	const divisionMinutes = totalMinutes / divisions;

	return Array.from({ length: divisions }, (_, i) => {
		const rangeStart = moment(start).add(i * divisionMinutes, 'minutes');
		const rangeEnd = moment(start).add((i + 1) * divisionMinutes, 'minutes');

		return {
			start: rangeStart.format(format),
			end: rangeEnd.format(format),
		};
	});
}
